import client from './client';

/**
 * Create a new booking
 * @param {Object} bookingData - { propertyId, checkInDate, checkOutDate, numberOfGuests, ...guestDetails }
 * @returns {Promise<Object>} { booking, cautionFee, isGuestBooking }
 */
export const createBooking = async (bookingData) => {
    const { data } = await client.post('/api/bookings', bookingData);
    return data;
};

/**
 * Get all bookings belonging to the current user
 * @returns {Promise<Array>} List of user bookings
 */
export const getMyBookings = async () => {
    const { data } = await client.get('/api/bookings/my');
    return data;
};

/**
 * Get details of a single booking
 * @param {number|string} id
 * @returns {Promise<Object>} Booking record
 */
export const getBookingById = async (id) => {
    const { data } = await client.get(`/api/bookings/${id}`);
    return data;
};

/**
 * Update booking status
 * @param {number|string} id
 * @param {string} status
 */
export const updateBookingStatus = async (id, status) => {
    const { data } = await client.patch(`/api/bookings/${id}/status`, { status });
    return data;
};

/**
 * Verify payment for a booking
 * @param {number|string} id
 * @param {string} reference
 * @param {string} gateway - 'paystack' or 'moments'
 */
export const verifyPayment = async (id, reference, gateway = 'paystack') => {
    const { data } = await client.post(`/api/bookings/${id}/verify-payment`, { reference, gateway });
    return data;
};
